module.exports = __webpack_public_path__ + "img/news_detail.c9a7acea.png";